export const initialInPageValue = {};

export const extractInPage = (payload) => {
    if (!payload?.inPageNav) {
        return initialInPageValue;
    }

    return validateInPageNavData(payload.inPageNav);
};

const validateInPageNavData = (data) => {
    if (!data?.navigation) return initialInPageValue;

    if (
        data.navigation.hasOwnProperty("name") &&
        data.navigation?.items &&
        Array.isArray(data.navigation.items)
    ) {
        return data.navigation;
    }

    return initialInPageValue;
};
